// The "Unpaid" toggle in the Invoice search tab is a three-state checkbox
// (-1 = Unpaid, 0 = Paid, null = All). It doesn't map to a column on the
// invoices table; instead it scopes the underlying invoicesV2 query via
// the `balanceAmount` HAVING filter (a SUM of line totals).
//
// The 0.01 tolerance keeps tiny floating-point residues on summed line
// totals from being treated as unpaid balances.
const balanceAmountFilterForUnpaidState = unpaid => {
  if (unpaid === -1) return { value: 0.01, operator: "gt" };
  if (unpaid === 0) return { value: 0.01, operator: "lte" };
  return null;
};

export { balanceAmountFilterForUnpaidState };
